import { Popover } from "@headlessui/react";
import React, { useContext, useEffect, useState } from "react";
import Navbar from "../components/navbar";
import BackButton from "../components/back_button";
import { AuthContext } from "../contexts/auth"
import { months, years } from "../config";
import { fetchEmployee, uploadBustePagaMassive, uploadCuSingolo, uploadDocumentiSingolo } from "../services/api";
import { useParams } from "wouter";
import UploadForm from "../components/upload_form";
import PopoverComponentCustom from "../components/popover_component";
import Footer from "../components/footer";
import Fetching from "../components/fetching";
import { Link } from "wouter";
import DocumentForm from '../components/document_form';


export default function UploadSingleDoc() {
  
  const { codiceFiscale } = useParams();
  const { profile, token } = useContext(AuthContext)

  const [fetching, setFetching] = useState(true)
  const [employee, setEmployee] = useState(null)

  const isProfileComplete = profile.has_complete_profile;

  useEffect(() => {
    if (token && !fetching) {
      console.log(token)
      setFetching(true)
    }
    fetchEmployee(token, codiceFiscale)
      .then((res) => {
        setEmployee(res)
        setFetching(false)
      })
      .catch((err) => {
        console.log(err)
        setFetching(false)
      })
  }, [token])

  return (
    <div className='flex flex-col min-h-screen'>
      <div className="flex-grow">
        <PopoverComponentCustom title='Carica documento' />
        {profile?.customer_type === 'company' && !isProfileComplete && profile?.company?.email == profile?.the_real_user_email && (
            <div className="w-full">
                <div className="bg-orange-100 text-orange-600 p-4 mb-6">
                    <p className="text-center text-sm font-semibold">
                        Il profilo non è completo. <br />
                        Compila i campi mancanti{' '}
                        <Link
                        to="/profilo/fatturazione"
                        className="text-indigo-600 hover:text-indigo-800 underline"
                        >
                        cliccando qui
                        </Link>
                    </p>
                </div>
            </div>
        )}
        <div className='mx-auto max-w-3xl px-4 sm:px-6 lg:max-w-7xl lg:px-8'>        
          <div className="flex items-center mb-4 mt-8">
            {
              employee ? <BackButton prevLocation={`/dipendenti/${employee.cf}`} /> : <BackButton prevLocation={`/dipendenti`} />
            }
          </div>
        </div>
        <main>
          <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:max-w-7xl lg:px-8 mb-8">
            {/* a div with a fake table */}
            <div className="">
              {fetching && (
                <Fetching />
              )}

              {(!fetching && employee) && (
                <>
                  <div className="bg-white px-6 lg:px-8 mb-10">
                    <div className="mx-auto max-w-2xl text-center">
                      <h2 className="text-2xl font-bold tracking-tight text-gray-900 sm:text-2xl">
                        Carica un documento per {employee.first_name} {employee.last_name}
                        <br />
                        <small>
                          {employee.cf}
                        </small>
                      </h2>
                      <p className="mt-6 text-lg leading-8 text-gray-600">
                        {
                          employee.email
                        }
                      </p>
                    </div>
                  </div>
                  <div className="bg-white rounded-lg shadow overflow-hidden p-6 ">
                    <DocumentForm employee={employee.employee} />
                  </div>
                </>
              )}
            </div>
          </div>
        </main>
      </div>
      <Footer />
    </div>
  )
}